import { __read } from 'tslib';

export function formatDate(date: Date) {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const format = `${year}-${month}-${day}T00:00:00.000Z`;
  return format;
}

export function compareValue(a: any, b: any) {
  if (a === b) return true;

  if (a && b) {
    if (a instanceof Date || b instanceof Date) {
      return toDate(a).valueOf() === toDate(b).valueOf();
    }

    if (a instanceof Array || b instanceof Array) {
      if (a.length !== b.length) return false;
      for (var i in a) {
        if (!compareValue(a[i], b[i])) {
          return false;
        }
      }
      return true;
    }
    if (a instanceof Object || b instanceof Object) {
      //if (Object.keys(a).length !== Object.keys(b).length) return false;

      for (let key of Object.keys(a)) {
        if (!compareValue(a[key], b[key])) {
          return false;
        }
      }
      return true;
    }
    return a === b;
  } else {
    return false;
  }
}

function isoStringToDate(match: string) {
  const date = new Date(0);
  let tzHour = 0;
  let tzMin = 0;
  // match[8] means that the string contains "Z" (UTC) or a timezone like "+01:00" or "+0100"
  const dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear;
  const timeSetter = match[8] ? date.setUTCHours : date.setHours;
  // if there is a timezone defined like "+01:00" or "+0100"
  if (match[9]) {
    tzHour = Number(match[9] + match[10]);
    tzMin = Number(match[9] + match[11]);
  }
  dateSetter.call(
    date,
    Number(match[1]),
    Number(match[2]) - 1,
    Number(match[3])
  );
  const h = Number(match[4] || 0) - tzHour;
  const m = Number(match[5] || 0) - tzMin;
  const s = Number(match[6] || 0);
  const ms = Math.round(parseFloat(`0.${match[7] || 0}`) * 1000);
  timeSetter.call(date, h, m, s, ms);
  return date;
}
function isDate(value: any) {
  return value instanceof Date && !isNaN(value.valueOf());
}

export function toDate(value: any) {
  if (isDate(value)) {
    return value;
  }
  if (typeof value === 'number' && !isNaN(value)) {
    return new Date(value);
  }
  if (typeof value === 'string') {
    value = value.trim();
    const parsedNb = parseFloat(value);
    // any string that only contains numbers, like "1234" but not like "1234hello"
    if (!isNaN(value - parsedNb)) {
      return new Date(parsedNb);
    }
    if (/^(\d{4}-\d{1,2}-\d{1,2})$/.test(value)) {
      /* For ISO Strings without time the day, month and year must be extracted from the ISO String
      before Date creation to avoid time offset and errors in the new Date.
      If we only replace '-' with ',' in the ISO String ("2015,01,01"), and try to create a new
      date, some browsers (e.g. IE 9) will throw an invalid Date error.
      If we leave the '-' ("2015-01-01") and try to create a new Date("2015-01-01") the timeoffset
      is applied.
      Note: ISO months are 0 for January, 1 for February, ... */
      const _a = __read(
          value.split('-').map(function (val: any) {
            return +val;
          }),
          3
        ),
        y = _a[0],
        m = _a[1],
        d = _a[2];
      return new Date(y, m - 1, d);
    }
    let match = void 0;
    const ISO8601_DATE_REGEX =
      /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;

    if ((match = value.match(ISO8601_DATE_REGEX))) {
      const isoDate = isoStringToDate(match);
      if (isoDate.getFullYear() === 1) return null;
      return isoDate;
    }
  }
  if (value) {
    const date = new Date(value);
    if (!isDate(date)) {
      throw new Error(`Unable to convert "${value}" into a date`);
    }
    return date;
  }
  return null;
}

export function readJson<T>(target: T | any, json: any) {
  for (const key in json) {
    if (target[key] instanceof Date) {
      target[key] = toDate(json[key]);
    } else {
      target[key] = json[key];
    }
  }
}

export function formatJson(data: any) {
  const js: any = {};
  for (const key in data) {
    if (data[key] instanceof Date && data[key]) js[key] = formatDate(data[key]);
    else js[key] = data[key];
  }
  return js;
}

export function getChangedValues(current: any, original: any) {
  const modified: any = {};
  let hasChanges = false;
  if (original) {
    Object.keys(original).forEach(key => {
      if (!key.startsWith('_') && !compareValue(current[key], original[key])) {
        modified[key] = { newValue: current[key], oldValue: original[key] };
        hasChanges = true;
      }
    });
  }
  if (hasChanges) return modified;
  else return null;
}
